import React from "react";
import { Link } from "react-router-dom";

const AboutUsSection = () => {
  return (
    <>
      <div class="about2 about-page-sec sp">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-6">
              <div class="about2-images">
                
                <div class="image2">
                  <img src="/assets/img/about/about2-img2.jpeg" alt="" />
                </div>
                
                <div class="counter-box">
                  <h3>17</h3>
                  <p>
                    Years Of <br /> Experience
                  </p>
                </div>
              </div>
            </div>

            <div class="col-lg-6">
              <div class="heading1">
                <span class="span">
                  <img src="/assets/img/icons/span1.png" alt="" /> About Us
                </span>
                <h2>Exchange Rate API by IBRLIVE</h2>
                <div class="space16"></div>
                <p>
                  Welcome to the Exchange Rate API – a powerful, accurate, and
                  developer-friendly tool brought to you by IBRLIVE, India’s
                  trusted name in the foreign exchange consultancy space.
                  Designed to support developers, fintech platforms, exporters,
                  and global businesses, our API provides seamless access to
                  real-time and historical currency exchange rates. Whether
                  you’re building a pricing engine, a money transfer service, or
                  an international invoicing tool, our exchange rate API gives
                  you the data backbone to power your application with
                  confidence and precision.
                </p>

                <div class="space10"></div>

                {/* <div class="porgress-line-all">
                    <div class="progress-line">
                      <div class="heading">
                        <h6>IT Consulting</h6>
                        <p>80%</p>
                      </div>
                      <div class="progress">
                        <div class="progress-bar w-75" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>
                      </div>
                    </div>
                    <div class="progress-line">
                      <div class="heading">
                        <h6>Cyber Security</h6>
                        <p>90%</p>
                      </div>
                      <div class="progress">
                        <div class="progress-bar w-75" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>
                      </div>
                    </div>
                  </div> */}

                <div class="space30"></div>
                <div class="button">
                  <Link class="theme-btn1" to="/dashboard">
                    Start Free Plan{" "}
                    <span>
                      <i class="fa-solid fa-arrow-right"></i>
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutUsSection;
